export const MY_MENU = 1

export const TAX = 2
